import { PcApiResponse } from '@/api/pc-api/types';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type CompanyDetailInfo = {
  id: string;
  businessClassification: string;
  businessNumber: string;
  name: string;
  representativeName: string;
  businessCategory: string;
  businessCategoryItem: string;
  baseAddress: string;
  detailAddress: string;
  zipcode: string;
};

export const getCompanyByAuthInfoId = (targetId: string) => {
  return api<PcApiResponse<CompanyDetailInfo>>('get', `/pc-api/v1/${PREFIX_PATH}/company`, { targetId });
};
